import React from 'react';
import {
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
} from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { actionSubmitForm } from 'store/actions/usersActions';

/**
 * @component DoctorUsersEditMembership
 * @description Form component to edit the membership type of a doctor.
 * Submits the updated membership data using the global Redux action.
 */
const DoctorUsersEditMembership = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const userData = useSelector(state => state.userDoctorsReducer.editData);
  
  const { register, handleSubmit } = useForm({
    defaultValues: {
      membership: userData?.membership || 'basic'
    }
  });

  /**
   * Submits the form data, merging it with the existing user data.
   *
   * @param {Object} data - Form data containing the membership selection.
   */
  const onSubmit = (data) => {
    dispatch(actionSubmitForm({ ...userData, ...data }));
    history.goBack();
  };

  const fullName = `${userData?.firstName || ''} ${userData?.lastName || ''}`.trim();
  const prefix = userData?.gender ? `${userData.gender} ` : '';

  return (
    <>
      <CardHeader>{`${prefix}${fullName} membership edition form`.trim()}</CardHeader>
      <CardBody>
        <Form id="user-edit-form" onSubmit={handleSubmit(onSubmit)}>
          <Label>Membership</Label>
          <FormGroup>
            <Input
              type="select"
              name="membership"
              required
              innerRef={register}
            > 
              <option value="full">Full</option>
              <option value="basic">Basic</option>
            </Input>
          </FormGroup>
        </Form>

        <Button form="user-edit-form" size="sm" color="info" type="submit" className="mr-2">
          Update
        </Button>

        <Button
          size="sm"
          color="danger"
          type="button"
          onClick={(e) => {
            e.preventDefault();
            history.goBack();
          }}
        >
          Cancel
        </Button>
      </CardBody>
    </>
  );
};

export default DoctorUsersEditMembership;